import _ from 'lodash';
import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { RSS } from '@bibliocommons/base-icons';

const RSS_WINDOW_NAME = 'RSSWindow';
const RSS_WINDOW_OPTIONS = _({
  resizable: 1,
  status: 0,
  toolbar: 0,
  scrollbars: 1,
  location: 0,
  menubar: 0
}).map((value, key) => `${key}=${value}`)
  .value()
  .join(',');

export default function RSSButton({ url }) {
  const onClick = (e) => {
    e.preventDefault();
    window.open(url, RSS_WINDOW_NAME, RSS_WINDOW_OPTIONS);
  };

  return (
    <a href={url} className="btn btn-link cp-rss-button" onClick={onClick}>
      <RSS />
      <ScreenReaderMessage>
        <FormattedMessage id="ada_rss_button" />
      </ScreenReaderMessage>
    </a>
  );
}

RSSButton.propTypes = {
  url: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/components/search/RSSButton.jsx